import React from 'react';
import { clients } from '../../data/clients';
import './Clients.scss';

const trustItems = [
  { icon: '🏆', number: '120+', label: 'Clients Served'     },
  { icon: '📦', number: '500+', label: 'Projects Completed' },
  { icon: '🌐', number: '18',   label: 'States Covered'     },
  { icon: '⭐', number: '98%',  label: 'Client Retention'   },
];

const Clients = () => (
  <section className="clients-section" id="clients">
    <div className="container">
      <div className="section-header">
        <span className="badge-label">Trusted By</span>
          <h2>Companies That Rely on Aavjo Industries</h2>
        <div className="section-divider" />
        <p>
          From start-ups scaling their first production line to Fortune 500 
          manufacturers — Aavjo Industries serves clients across industries and scale.
        </p>
      </div>

      <div className="clients-grid">
        {clients.map(client => (
          <div key={client.id} className="client-tile">
            <div className="client-logo">
              <img src={client.logo} alt={client.name} />
            </div>
            <span className="client-name">{client.name}</span>
          </div>
        ))}
      </div>

      <div className="trust-strip">
        {trustItems.map(item => (
          <div key={item.label} className="strip-item">
            <span className="strip-icon">{item.icon}</span>
            <div className="strip-body">
              <div className="strip-number">{item.number}</div>
              <div className="strip-label">{item.label}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Clients;
